/* eslint-disable react/jsx-sort-props */
import * as React from 'react';
import * as vars from '../../styles/variables';
import AccessibleSVG, { SVGProps } from '../../components/accessible-svg/AccessibleSVG';

/**
 * This is an auto-generated component and should not be edited
 * manually in contributor pull requests.
 *
 * If you have problems with this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Bug_report.md
 *
 * If there are missing features in this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Feature_request.md
 */

const FileAudio32 = (props: SVGProps) => (
    <AccessibleSVG width={32} height={32} viewBox="0 0 32 32" {...props}>
        <g fill="none">
            <path
                fill={vars.bdlPurpleRain}
                d="M9 3h9.172a2 2 0 011.414.586l5.83 5.828A2 2 0 0126 10.83V26a3 3 0 01-3 3H9a3 3 0 01-3-3V6a3 3 0 013-3z"
            />
            <path
                fill={vars.white}
                fillOpacity={0.5}
                d="M19.286 3.286l5.01 5.009 1.412 1.412a1 1 0 01.203.293H21a2 2 0 01-2-2V3.09a1 1 0 01.286.196z"
            />
            <path
                fill={vars.white}
                d="M18.75 17h-5.5a.25.25 0 00-.25.25v4.25a1.5 1.5 0 11-1.5-1.5.9.9 0 01.5.1v-6.35a.75.75 0 01.75-.75h6.5a.75.75 0 01.75.75v7.75a1.5 1.5 0 11-1.5-1.5.9.9 0 01.5.1v-2.85a.25.25 0 00-.25-.25zm-5.5-1h5.5a.25.25 0 00.25-.25V14.5a.5.5 0 00-.5-.5h-5a.5.5 0 00-.5.5v1.25c0 .138.112.25.25.25z"
            />
        </g>
    </AccessibleSVG>
);

export default FileAudio32;
